export var WithProviders = function (_a) {
    var providers = _a.providers, children = _a.children, additionalProps = _a.additionalProps;
    return providers.reduce(function (child, getProvider) {
        return getProvider(child, additionalProps || {});
    }, children);
};
//# sourceMappingURL=utils.js.map